// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"66c3695c","397":"85214823","535":"7040fede"}[chunkId] + ".chunk.js";
};